// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '../views/login';
// 首页
import index from '../views/index'


//视图
import rangking from '@/views/home/rangking';
//首页
import home from '@/views/home/home'

//开工销售比
import reading from '@/views/home/reading'

//年度城与全图倍数对比接口
import yearc from '@/views/home/year_city'

//月度城与全图倍数对比接口
import mouth from '@/views/home/mouth'

//年度城与全图同比对比接口
import yearct from '@/views/home/year_ct'
//月度城与全图同比对比接口
import mouth_ct from '@/views/home/mouth_ct'



// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [
{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path:'/index',
    component: index,
    children: [{
      path: '/home/rangking',
      name: '年度',
      component: rangking,
      meta: {
        requireAuth: true
      }
    },{
      path: '/home/home',
      name: '月度',
      component: home,
      meta: {
        requireAuth: true
      }
      },{
        path: '/home/reading',
        name: '开工销售比',
        component: reading,
        meta: {
          requireAuth: true
        }
      },{
        path: '/home/year_city',
        name: '年度城与全图倍数对比',
        component: yearc,
        meta: {
          requireAuth: true
        }
      },{
        path: '/home/mouth',
        name: '月度城与全图倍数对比',
        component: mouth,
        meta: {
          requireAuth: true
        }
      },{
        path: '/home/year_ct',
        name: '月度城与全图同数对比',
        component: yearct,
        meta: {
          requireAuth: true
        }
      },{
        path: '/home/mouth_ct',
        name: '月度城与全图同比对比',
        component: mouth_ct,
        meta: {
          requireAuth: true
        }
      },]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js